<template>
  <div v-for="(item, key) in asset" :key="key" class="border-b border-primary-500 px-4 py-2.5 mb-6">
    <div class="text-slate-400 text-xs font-light capitalize">{{ key }}</div>
    <div class="text-slate-600">{{ item ?? '-' }}</div>
  </div>
</template>

<script setup>
defineProps({
  asset: {
    type: Object,
    default: () => {}
  }
});
</script>
